module.exports = __webpack_public_path__ + "img/ja.22e3b3a4.svg";